export const prodApptopiaUrl = 'https://apptopia.com';

export const demoPageUrl = `${prodApptopiaUrl}/en/lead-gen`;

export const alphaIntelligenceUrl = `${prodApptopiaUrl}/alpha-intelligence`;
export const bloombergAppUrl = `${prodApptopiaUrl}/bloomberg-app`;
export const publicFinanceUrl = `${prodApptopiaUrl}/public-finance`;

export const financeReportPageUrl = `${prodApptopiaUrl}/free-company-intelligence-report`;
export const marketReportPageUrl = `${prodApptopiaUrl}/free-competitive-intelligence-report`;
export const alchemyPricingPath = `${prodApptopiaUrl}/pricing`;
